import css from 'styled-jsx/css';
import { colors } from '../../../themes';

export default css`
  .button-link {
    align-items: center;
    background: transparent;
    cursor: pointer;
    border: none;
    display: flex;
    justify-content: center;
    padding: 0 10px;
    position: relative;
    width: 100%;
  }

  p {
    color: ${colors.blue};
    font-size: 0.86em;
    font-weight: 400;
    text-align: center;
  }
`;



// WEBPACK FOOTER //
// ./app/common/Buttons/ButtonLink/styles.js